import { toBaseUrl, toProjectId, toProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { createHook, createStore, createContainer } from '@atlassian/react-sweet-state';
import { getReportsQueryParams } from '../../common/helpers/index.tsx';
import type { RouterProps } from '../../common/helpers/types.tsx';
import * as actions from './actions/index.tsx';
import type { State, ReportsProjectContext } from './types.tsx';

export type Actions = typeof actions;

export const initialState: State = {
	dateFilterQuery: {
		reportId: '',
		timescaleId: 0,
	},
	baseUrl: toBaseUrl(''),
	projectKey: toProjectKey(''),
	projectId: toProjectId(''),
	projectName: '',
};

export const store = createStore<State, Actions>({
	name: 'CustomReportsUiState',
	initialState,
	actions,
});

export type PropType = {
	routerProps?: RouterProps;
} & ReportsProjectContext;

export const useUIStateStore = createHook(store);

const onContainerChange =
	() =>
	// @ts-expect-error - TS7031 - Binding element 'getState' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'routerProps' implicitly has an 'any' type.
	({ getState, setState }, { routerProps, ...projectContext }) => {
		const { dateFilterQuery } = getState();
		if (routerProps && routerProps.timescaleId === undefined) {
			setState({
				dateFilterQuery: getReportsQueryParams({
					...dateFilterQuery,
					reportId: routerProps.reportId || '',
				}),
				...projectContext,
			});
		} else {
			setState({
				dateFilterQuery: getReportsQueryParams(routerProps || { reportId: '' }),
				...projectContext,
			});
		}
	};

export const UIStateContainer = createContainer<State, Actions, PropType>(store, {
	// @ts-expect-error - TS2322 - Type '() => ({ getState, setState }: { getState: any; setState: any; }, { routerProps, ...projectContext }: { [x: string]: any; routerProps: any; }) => void' is not assignable to type '() => Action<State, PropType, void | Promise<void>>'.
	onInit: onContainerChange,
	// @ts-expect-error - TS2322 - Type '() => ({ getState, setState }: { getState: any; setState: any; }, { routerProps, ...projectContext }: { [x: string]: any; routerProps: any; }) => void' is not assignable to type '() => Action<State, PropType, void | Promise<void>>'.
	onUpdate: onContainerChange,
});
